export const juniorsCourseGroups = {
  Basics: 'Basics',
  NumberSystem: 'Number system',
  Python: 'Python',
  ProblemSolvingBeginners: 'Problem solving beginners',
  FrontEndDevelopment: 'Frontend development',
};
